import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { z } from "zod";
import { AlcDrawer, DrawerTitle } from "../ui/drawer";
import { Form, FormField, FormItem, FormLabel } from "../ui/form";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import {
  selectEvent,
  setCustomEvent,
} from "src/lib/slices/drinkSelectionSlice";

const FormSchema = z.object({
  name: z.string().min(1),
});

export default function CustomEventDrawer({ children }) {
  const dispatch = useDispatch();

  const customEvent = useSelector(
    (state: any) => state.drinkSelection.customEvent
  );

  const [isOpen, setIsOpen] = useState(false);

  const form = useForm<z.infer<typeof FormSchema>>({
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
    defaultValues: {
      name: customEvent.text ?? "",
    },
  });

  const onSubmit = (data) => {
    dispatch(
      setCustomEvent({
        text: data.name,
      })
    );
    dispatch(selectEvent("custom"));
    setIsOpen(false);
  };

  return (
    <AlcDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={children}
      asChild
      header={
        <>
          <DrawerTitle className="text-center">Vlastní událost</DrawerTitle>
        </>
      }
    >
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Název</FormLabel>
                <Input type="text" autoComplete="name" id="name" {...field} />
              </FormItem>
            )}
          />
          <div className="py-4">
            <Button type="submit" className="w-full">
              Vybrat
            </Button>
          </div>
        </form>
      </Form>
    </AlcDrawer>
  );
}
